import React, { useEffect, useState } from 'react';
import config from "../../config.json";
import { Col, Card, Row, Checkbox, Button, Collapse, Radio, Spin, Progress, Form, Space, Modal, Alert } from 'antd'
import { ExclamationCircleOutlined, UserSwitchOutlined } from '@ant-design/icons';
import DataDisplayWidget from 'cl-library/dist/components/shared-components/DataDisplayWidget';
import axios from 'axios';
import ErrorPage from '../error-views/errorPage'

const { Panel } = Collapse;
let newFourParent = [];
let panelIndex = 0;
let panelIndexArray = [];

const ParentAudit = ({ RMCode }) => {
    const cl = localStorage.getItem("CL");
    const token = localStorage.getItem("token");
    const [form] = Form.useForm();
    const [fourParent, setFourParent] = useState([]);
    const [warningBack, setwarningBack] = useState(false);
    const [filledData, setFilledData] = useState(0);
    const [loading, setLoading] = useState(true);
    const [apiError, setapiError] = useState(null);
    const [alert, setAlert] = useState(false)
    const [oneAlert, setOneAlert] = useState(false)
    const [twoAlert, setTwoAlert] = useState(false)
    const [finalAlert, setFinalAlert] = useState(false)

    useEffect(() => {
        async function fetchData() {
            let url = config.getParentAuditData + cl + '&RMcode=' + RMCode;

            axios.get(url, { headers: { 'Authorization': token } })
                .then(resp => {
                    if (resp.data.status === "error") setapiError(resp.data);
                    newFourParent = resp.data
                    setFourParent(resp.data)
                    setLoading(false)
                }, error => {
                    setapiError(error.response);
                });

            let filterData = newFourParent.filter((item) => item.Total_working_days !== "")
            setFilledData(filterData.length)
        }
        fetchData();
    }, []);

    const panelChange = (value) => {
        panelIndex = value;
        panelIndexArray.push(value);
    }

    const onChange = e => {
        newFourParent[panelIndex].Total_working_days = e.target.value
        let filterData = newFourParent.filter((item) => item.Total_working_days !== "")
        setFilledData(filterData.length)
    }

    const selectOption = (e) => {
        let value = e.target.value
        let checked = e.target.checked

        if (value === 'RM_send_morning_messages') {
            if (checked)
                newFourParent[panelIndex].RM_send_morning_messages = "1";
            else
                newFourParent[panelIndex].RM_send_morning_messages = "0";
        }

        if (value === 'Does_RM_follow_up') {
            if (checked)
                newFourParent[panelIndex].Does_RM_follow_up = "1";
            else
                newFourParent[panelIndex].Does_RM_follow_up = "0";
        }

        if (value === 'Does_RM_tell_marks_daily') {
            if (checked)
                newFourParent[panelIndex].Does_RM_tell_marks_daily = "1";
            else
                newFourParent[panelIndex].Does_RM_tell_marks_daily = "0";
        }
        let filterData = newFourParent.filter((item) => item.Total_working_days !== "")
        setFilledData(filterData.length)
    }

    const submit = () => {
        let filterNewData = newFourParent.filter((item) => item.Total_working_days !== "")
        let finalFarentAuditScore = parentAuditScoreCalc();

        if (filterNewData.length === 0) {
            setOneAlert(true)
        }
        else if (filterNewData.length === 1) {
            setTwoAlert(true)
        }
        else if (filterNewData.length === 2) {

            let url = config.postParentAuditresponse + cl + '&RMcode=' + RMCode;

            axios.post(url, { parentData: filterNewData })
                .then(resp => {
                    if (resp.data.status === "error") setapiError(resp.data);
                }, error => {
                    setapiError(error.response);
                })

            let url2 = config.postAuditParentScore + cl + '&RMcode=' + RMCode;
            axios.post(url2, { finalFarentAuditScore: finalFarentAuditScore })
                .then(resp => {
                    if (resp.data.status === "error") setapiError(resp.data);
                    setAlert(true)
                    window.location = "/omPortal/app/CentalAudit";
                }, error => {
                    setapiError(error.response);
                })
        }
        else {
            setFinalAlert(true)
        }
    }

    const parentAuditScoreCalc = () => {
        let filterNewData = newFourParent.filter((item) => item.Total_working_days !== "")
        let positiveScore = filterNewData.length * 3;
        let negativeScore = filterNewData.reduce((acc, cur) => {

            if (cur.RM_send_morning_messages === "0")
                ++acc;
            if (cur.Does_RM_follow_up === "0")
                ++acc;
            if (cur.Does_RM_tell_marks_daily === "0")
                ++acc;
            return acc
        }, 0)

        let parentAuditScore = (((positiveScore - negativeScore) / positiveScore) * 100)
        return Math.round(parentAuditScore, 2)
    }

    const back = () => {
        setwarningBack(!warningBack)
    }

    function cancel(e) {
        setwarningBack(false)
        window.location = "/omPortal/app/CentalAudit";
    }
    const onCloseOne = e => {
        setOneAlert(false)
    };
    const onCloseTwo = e => {
        setTwoAlert(false)
    };

    if (apiError) {
        return <ErrorPage details={apiError} />
    }
    else if (loading) {
        return <Spin tip="Loading..."></Spin>
    }
    else {
        return (
            <>
                <Row gutter={16}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className='text-center'>
                        <Row gutter={[8, 8]}>
                            <Col xs={24} sm={24} md={24} lg={16} xl={16} xxl={16}>
                                <Card style={{ height: 110 }}>
                                    <h4>नीचे दिए गए 6 पैरेंट में से किसी 2 पैरेंट का ऑडिट भरे ।</h4>
                                </Card>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                <Card style={{ height: 110 }}>
                                    <Progress
                                        status={filledData < 2 ? "exception" : "success"}
                                        percent={(filledData / 2) * 100}
                                        format={percent => `${percent}% Audit`}
                                        type='circle'
                                        width={80}
                                    />
                                </Card>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                <DataDisplayWidget
                                    icon={<UserSwitchOutlined />}
                                    value={newFourParent.length}
                                    title="Total Student"
                                    color="cyan"
                                    size={5}
                                    vertical={true}
                                    avatarSize={20}
                                    style={{ height: 110 }}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Card>
                    <Form
                        form={form}
                        name="basic"
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={"onFinish"}
                    >
                        <Collapse onChange={panelChange} accordion>
                            {fourParent ?
                                fourParent.map((item, index) => (

                                    <Panel header={`${item.Student_name} - ${item.Token_no}`} key="" >

                                        <Row gutter={[8, 24]}>
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>

                                                <Col style={{ 'backgroundColor': 'lavender', 'textAlign': 'center' }}>Student Info</Col>
                                                <Row gutter={[24, 24]}>
                                                    <Col span={14} style={{ 'textAlign': 'right' }}><b>Token Number:</b></Col>
                                                    <Col span={10}>{item.Token_no}</Col>
                                                </Row>
                                                <Row gutter={[24, 24]}>
                                                    <Col span={14} style={{ 'textAlign': 'right' }}><b>Student Name:</b></Col>
                                                    <Col span={10}>{item.Student_name}</Col>
                                                </Row>
                                                <Row gutter={[24, 24]}>
                                                    <Col span={14} style={{ 'textAlign': 'right' }}><b>Mother Name:</b></Col>
                                                    <Col span={10}>{item.Mother_name}</Col>
                                                </Row>
                                                <Row gutter={[24, 24]}>
                                                    <Col span={14} style={{ 'textAlign': 'right' }}><b>Phone Number:</b></Col>
                                                    <Col span={10}>{item.Calling_no}</Col>
                                                </Row>
                                                <Row gutter={[24, 24]}>
                                                    <Col span={14} style={{ 'textAlign': 'right' }}><b>RPW:</b></Col>
                                                    <Col span={10}>{item.RPW ? item.RPW : 0}</Col>
                                                </Row>
                                            </Col>

                                            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                                <Col style={{ 'backgroundColor': 'lavender', 'textAlign': 'center' }}>Audit Parent</Col>
                                                <Col span={24}>
                                                    <Checkbox value="RM_send_morning_messages" onChange={selectOption}>क्या आपको रोज सुबह आरएम मेसेज भेजती है?</Checkbox>
                                                </Col>
                                                <Col span={24}>
                                                    <Checkbox value="Does_RM_follow_up" onChange={selectOption}>अगर कभी आप रिप्लाई नही कर पाते आरएम फॉलो अप लेती है?</Checkbox>
                                                </Col>

                                                <Col span={24}>
                                                    <Checkbox value="Does_RM_tell_marks_daily" onChange={selectOption}>आरएम आपको आपके बच्चे के मार्क्स रोज़ बताती है?</Checkbox>
                                                </Col>

                                                <Col span={24}>
                                                    <label>आप हफ्ते में कितने दिन काम करते हो?</label><br />
                                                    <Radio.Group onChange={onChange}>
                                                        <Space direction="vertical">
                                                            <Radio value='0'>1 से 2 दिन</Radio>
                                                            <Radio value='1'>3 से 4 दिन</Radio>
                                                            <Radio value='2'>5 से 6 दिन</Radio>
                                                            <Radio value='3'>0 दिन काम करते हो</Radio>
                                                        </Space>
                                                    </Radio.Group>
                                                </Col>

                                            </Col>
                                        </Row>

                                    </Panel>
                                )) : null
                            }
                        </Collapse>

                        {oneAlert ? <Alert
                            message="Warning"
                            description="Audit not done. Please do 2 parent audit."
                            type="warning"
                            showIcon
                            details={oneAlert}
                            closable
                            onClose={onCloseOne}
                            style={{ marginTop: "5px" }}
                        />
                            :
                            ""}
                        {twoAlert ? <Alert
                            message="Warning"
                            description="You have Done only 1 parent Audit. Please do 1 more parent audit."
                            type="warning"
                            showIcon
                            details={twoAlert}
                            closable
                            onClose={onCloseTwo}
                        />
                            :
                            ""}
                        {alert ? <Alert
                            message="Success"
                            description="Today's Parent Audit done Successfully!"
                            type="success"
                            showIcon
                            details={alert}
                        />
                            :
                            ""}
                        {finalAlert ? <Alert
                            message="Warning"
                            description="You have done more than 2 parent audit. Please refresh the page and fill again."
                            type="warning"
                            showIcon
                            details={finalAlert}
                        />
                            :
                            ""}
                        <Row gutter={[4, 4]}>
                            <Col xs={12} sm={12} md={12} lg={18} xl={20} xxl={20}>
                                <Button onClick={back} type='link' className='m-2'>Go Back</Button>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                <Button className='m-2' type='primary' onClick={submit}>Submit</Button>
                            </Col>
                        </Row>

                    </Form>
                </Card>

                <Modal
                    title="Warning!!!"
                    visible={warningBack}
                    okText={"No"}
                    cancelText={"Yes"}
                    onOk={back}
                    onCancel={cancel}
                >
                    <h3><ExclamationCircleOutlined style={{ color: "orange" }} /> क्या आप वापस जाना चाहते हो ? </h3>
                    <p>अगर आप वापस गए तो आपका भरा हुआ डाटा हट जाएगा ।</p>
                </Modal>
            </>
        )

    }

}

export default ParentAudit;
